import { Fragment, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Textarea } from 'app/components/core/Textarea';
import * as styles from './MaskedTextarea.css';

const maskContent = (content) =>
    content
        ?.split('')
        .map((char) => (char !== '\n' ? '•' : char))
        .join('');

export function MaskedTextarea({ value, onChange }) {
    const { t } = useTranslation();
    const maskRef = useRef(null);
    const handleScroll = (event) => {
        maskRef.current.scrollTop = event.target.scrollTop;
    };

    return (
        <Fragment>
            <Textarea
                placeholder={t('admin:SnowflakeSettings.privateKey.inputPlaceholder')}
                onChange={onChange}
                className={styles.privateKey}
                onScroll={handleScroll}
                spellCheck="false"
                value={value}
            />
            <div ref={maskRef} className={styles.privateKeyMasked} id="maskedPrivateKey">
                {maskContent(value)}
            </div>
        </Fragment>
    );
}
